import { render, staticRenderFns } from "./SmsSetupModal.vue?vue&type=template&id=11c9c4fb&scoped=true"
import script from "./SmsSetupModal.vue?vue&type=script&lang=js"
export * from "./SmsSetupModal.vue?vue&type=script&lang=js"
import style0 from "./SmsSetupModal.vue?vue&type=style&index=0&id=11c9c4fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9c4fb",
  null
  
)

export default component.exports